import React, { Dispatch, SetStateAction } from "react";
import { ShopOutlined, UserOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import { Button, Dropdown } from "antd";
import { isBlMemberUser, isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { Link } from "react-router-dom";

interface Props {
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const ProfileButton: React.FC<Props> = ({ setOpen }) => {
  const { currentUser, logOut } = useLoginContext();
  const isCompany = isCompanyUser(currentUser);
  const isBlMember = isBlMemberUser(currentUser);

  /* The profile button is a dropdown menu that consist of a my profile button and a log out button. 
  If user is BL member, admin-pages will also be visible */
  const items: MenuProps["items"] = [
    ...(isBlMember ? [{ key: "1", label: <Link to="/admin/">Internsidene</Link> }] : []),
    {
      key: "2",
      label: (
        <Link to={isCompany ? "/company/company-profile/" : "/student-profile/"} onClick={() => setOpen(false)}>
          {isCompany ? "Min side" : "Min profil"}
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <Link
          to="/"
          onClick={() => {
            setOpen(false);
            logOut();
          }}
        >
          Logg ut
        </Link>
      ),
      danger: true,
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight">
      <Button block>
        {isCompany ? <ShopOutlined /> : <UserOutlined />} {currentUser?.username}
      </Button>
    </Dropdown>
  );
};

export default ProfileButton;
